import { render, staticRenderFns } from "./IcArrowTop.vue?vue&type=template&id=fe4d08d2&scoped=true"
import script from "./IcArrowTop.vue?vue&type=script&lang=js"
export * from "./IcArrowTop.vue?vue&type=script&lang=js"
import style0 from "./IcArrowTop.vue?vue&type=style&index=0&id=fe4d08d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4d08d2",
  null
  
)

export default component.exports